import React from 'react';
import './About.css';

import aboutImage from '../../../assets/images/about/about.webp';

const About = () => {
  return (
    <section id="sobre" className="about-section">
      <div className="about-container">

        <div className="about-content">

          <div className="about-image">
            <div className="about-image-wrapper">
              <div
                className="about-image-bg"
                style={{ backgroundImage: `url(${aboutImage})` }}
              >
                <div className="about-image-overlay"></div>
              </div>
            </div>
          </div>

          <div className="about-text">

            <div className="about-intro">
              <h2 className="about-title">
                Um pouquinho
                <br />
                sobre nós
              </h2>

              <div className="about-description">
                <p>
                  Com mais de 10 anos de atuação no mercado, o Grupo Egel é
                  referência em empréstimo consignado, atendendo milhares de
                  clientes em todo o Brasil.
                </p>

                <p>
                  Nossa missão é oferecer soluções financeiras acessíveis e
                  transparentes, ajudando nossos clientes a realizarem seus
                  sonhos e projetos com segurança e confiança.
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default About;